import { AxiosResponse } from "axios"

export type PromiseOptions = {
    more?: string,
}

export const onPromise = (self: any) => {
    return async (
        promise: (props?: any) => Promise<AxiosResponse>,
        options?: PromiseOptions,
    ): Promise<any> => {
        const more = options?.more || undefined;
        self.onPending();

        const { status, data, headers } = await promise();

        //READY
        if(status === 200 || status === 201 || status === 204) {
            if (more) {
                self.onMore(data, more, headers)
            }
            self.onReady(data, headers);
        }

        //ERROR
        else {
            self.onError({...data, status}, headers);
        }
    }

}